import './root.scss';
import React, { Component } from 'react';
import TreeViewContainer from './../../tree-view/tree-view-container';
import DocsHallmarks from './../../docs-hallmarks/view/hallmarks-container';
import config from './../../../config.js';
import MediaQuery from './../../common/mediaQueries';

import RootResizeHoc from './root-resize-hoc';

class RootView extends Component {

  componentWillMount() {
    const { changeIsMobilePhone, changeIsTablet, changeVisibleTabs } = this.props;
    if (MediaQuery.phoneLandscape.matches || MediaQuery.phonePortrait.matches) {
      changeIsMobilePhone(true);
      changeIsTablet(false);
    } else if(MediaQuery.iPadLandscape.matches || MediaQuery.iPadPortrait.matches) {
      changeIsMobilePhone(false);
      changeIsTablet(true);
    } else {
      changeIsMobilePhone(false);
      changeIsTablet(false);
    }
  }

  render() {

    return (
      <div>
        <div className='content' onMouseMove={(e)=>{ (this.props.isMobilePhone || this.props.isTablet) ? false : this.props.mouseMove(e); }}>
          <div className='contentLeft' style={this.props.contentLeftStyle}>
            <div className='contentLeftBottom'>
              <TreeViewContainer>
                <div className='header'>
                  <div className='pull-left'>
                    <img style={config.logoStyle} className='root-logo' src={'resources/' + config.customerLogo} onClick={()=> {
                      window.location.href = window.location.href.replace(window.location.search, '');
                    }}/>
                  </div>
                  <div className='pull-left appHeader'>
                    <p id='header-text'>{config.agTitleFirst}<b>{config.agTitleSecond}</b>{config.agTitleThird}</p>
                  </div>
                </div>
              </TreeViewContainer>
            </div>
          </div>
          <div id='treeResizeDivider' style={this.props.treeResizeDividerStyle} onMouseDown={(e)=>{(this.props.isMobilePhone || this.props.isTablet) ? false : this.props.mouseDownTreeDivider(e)}} onMouseUp={(e)=>{ (this.props.isMobilePhone || this.props.isTablet) ? false : this.props.mouseUp(e); }}/>
          <div className='contentRight' style={this.props.contentRightStyle}>
            <DocsHallmarks isMobilePhone={this.props.isMobilePhone} isTablet={this.props.isTablet} />
        </div>
      </div>
    </div>);
  }
}

export default RootResizeHoc(RootView);



/** WEBPACK FOOTER **
 ** app/components/root/view/root-view.js
 **/